export const DEFAULT_LTV = 25.36;

export const calculatePredictedLifeTimeValue = (...quizAnswers) =>
  quizAnswers.reduce((acc, val) => {
    return acc + val;
  }, DEFAULT_LTV);
